"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var react_1 = require("react");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var id_1 = require("tsafe/id");
var doExtends_1 = require("tsafe/doExtends");
function createIconButton(params) {
    var Icon = (params !== null && params !== void 0 ? params : {
        "Icon": id_1.id(function () { return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, {}, void 0); }),
    }).Icon;
    var useStyles = ThemeProvider_1.makeStyles()(function (theme, _a) {
        var disabled = _a.disabled;
        return ({
            "root": {
                "padding": theme.spacing(2),
                "&:hover": {
                    "backgroundColor": "unset",
                    "& svg": {
                        "color": theme.colors.useCases.buttons.actionHoverPrimary,
                    },
                },
            },
            "icon": {
                "color": theme.colors.useCases.typography[disabled ? "textDisabled" : "textPrimary"],
            },
        });
    });
    var IconButton = react_1.memo(react_1.forwardRef(function (props, ref) {
        var className = props.className, iconClassName = props.iconClassName, iconId = props.iconId, size = props.size, _a = props.disabled, disabled = _a === void 0 ? false : _a, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        children = props.children, _b = props.autoFocus, autoFocus = _b === void 0 ? false : _b, tabIndex = props.tabIndex, name = props.name, id = props.id, ariaLabel = props["aria-label"], 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["className", "iconClassName", "iconId", "size", "disabled", "children", "autoFocus", "tabIndex", "name", "id", "aria-label"]);
        var _c = useStyles({ disabled: disabled }), classes = _c.classes, cx = _c.cx;
        return (jsx_runtime_1.jsx(IconButton_1.default, __assign({ ref: ref, className: cx(classes.root, className), disabled: disabled, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : undefined, autoFocus: autoFocus, tabIndex: tabIndex, name: name, id: id }, (function () {
            if ("onClick" in rest) {
                var onClick = rest.onClick, href = rest.href, restRest = __rest(rest, ["onClick", "href"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ onClick: onClick, href: href }, restRest);
            }
            if ("href" in rest) {
                var href = rest.href, _a = rest.doOpenNewTabIfHref, doOpenNewTabIfHref = _a === void 0 ? true : _a, restRest = __rest(rest, ["href", "doOpenNewTabIfHref"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ href: href, "target": doOpenNewTabIfHref
                        ? "_blank"
                        : undefined }, restRest);
            }
            if ("type" in rest) {
                var type = rest.type, restRest = __rest(rest, ["type"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ type: type }, restRest);
            }
        })(), { children: jsx_runtime_1.jsx(Icon, { iconId: iconId, className: cx(classes.icon, iconClassName), size: size }, void 0) }), void 0));
    }));
    return { IconButton: IconButton };
}
exports.createIconButton = createIconButton;
//# sourceMappingURL=IconButton.js.map